<template>
  <div class="tip-page-box" :style="{background: backgroundColor}">
    <div class="left-tip-icon-box">
      <div class="left-tip">
        <img src="@/assets/images/tip/bule.png" alt="" v-if="color == 'bule'">
        <img src="@/assets/images/tip/gley.png" alt="" v-else-if="color == 'gley' || color == 'none'">
        <img src="@/assets/images/tip/yello.png" alt="" v-else-if="color == 'yello'">
        <img src="@/assets/images/tip/red.png" alt="" v-else-if="color == 'red'">
      </div>
    </div>
    <div class="right-tip-box">
      <slot>{{ text }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TipBox",
  props: {
    color: {
      type: String,
      // 支持蓝色bule、灰色gley、黄色yello、红色red
      default: 'bule',
    },
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    backgroundColor(){
      switch(this.color){
        case 'bule':
          return '#EBF3FF';
        case 'gley':
          return '#F4F4F5';
        case 'yello':
          return '#FFFBE6';
        case 'red':
          return '#FFF1F0';
        case 'none':
          return 'none';
        default: 
          return '#EBF3FF';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tip-page-box {
  width: 100%;
  padding: 9px 14px;
  border-radius: 2px;
  .left-tip-icon-box {
    width: 16.25px;
    height: 22px;
    margin-right: 10px;
    float: left;
    display: flex;
    justify-items: center;
    align-items: center;
    .left-tip {
      width: 16.25px;
      height: 16.25px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .right-tip-box {
    display: inline-block;
    width: calc(100% - 30px);
    color: #666666;
    font-size: 12px;
    line-height: 22px;
  }
}
</style>